import { render, staticRenderFns } from "./CancelBookingGroup.vue?vue&type=template&id=0e52cbde"
import script from "./CancelBookingGroup.vue?vue&type=script&lang=js"
export * from "./CancelBookingGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports